import { render, staticRenderFns } from "./date-range-2.vue?vue&type=template&id=5b837f72&"
import script from "./date-range-2.vue?vue&type=script&lang=js&"
export * from "./date-range-2.vue?vue&type=script&lang=js&"
import style0 from "./date-range-2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports